var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6 163.2C126.666 163.2 163.2 126.666 163.2 81.6C163.2 36.5336 126.666 0 81.6 0C36.5336 0 0 36.5336 0 81.6C0 126.666 36.5336 163.2 81.6 163.2Z",
    fill: "url(#paint0_linear_622_232)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.657 122.73V131.116C33.657 132.082 34.2885 132.713 35.2544 132.713H52.8246V123.728C52.8246 120.813 56.0189 120.813 56.0189 123.728V132.713H107.132V123.728C107.132 120.997 110.326 120.997 110.326 123.728V132.713H127.896C128.862 132.713 129.494 132.082 129.494 131.116C129.494 123.306 130.068 119.484 127.129 112.117C125.749 108.659 123.069 104.801 120.563 102.311L118.759 100.72C115.768 98.0474 109.371 94.7135 105.335 94.3779C105.498 94.9884 106.133 95.8067 106.133 97.1728C106.133 99.7728 103.879 101.323 102.489 102.714L93.2054 111.998C91.8591 113.344 90.0266 115.741 87.5649 115.741C84.4778 115.741 83.4512 113.004 81.575 111.748C80.2101 112.662 76.7588 118.368 72.3405 114.394C71.5317 113.667 70.8269 112.88 70.0446 112.098L60.7601 102.814C58.5155 100.569 55.562 98.6364 57.8154 94.3779C54.8884 94.6215 50.4713 96.6527 48.3666 97.9074C45.8312 99.4182 45.6051 99.8363 43.6686 101.395C41.9142 102.808 42.5398 102.463 41.1931 103.911C36.8489 108.584 33.6562 116.184 33.6562 122.73L33.657 122.73Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6111 58.2393V59.8366C53.2841 59.8366 51.9926 74.6116 62.809 74.6116C63.6543 78.239 67.956 83.173 71.3312 85.0575C78.6657 89.1526 87.3303 88.8115 93.9306 83.5705C95.2987 82.4844 96.5882 81.1493 97.6671 79.7198C98.516 78.5948 100.005 76.0745 100.346 74.6112C103.14 74.6112 104.351 74.1023 105.79 72.6684C110.85 67.6285 107.025 59.8362 101.544 59.8362C101.544 55.7011 101.42 56.442 94.1563 56.442C88.6726 56.442 83.3252 57.0965 80.0572 52.1724C77.5559 48.403 78.8839 46.459 76.5865 46.459C73.4878 46.459 76.7051 51.0911 71.5422 54.7919C66.6669 58.2865 61.6119 54.5242 61.6119 58.2389L61.6111 58.2393Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2191 59.2375L58.0913 57.5176C59.2535 56.8179 58.3813 56.2987 59.9231 54.7573C63.0467 51.6352 67.5742 55.0762 70.5412 51.5991C72.5796 49.2112 71.2821 47.1403 73.0635 44.9369C74.6406 42.9857 79.0629 42.6581 80.7174 45.7187C81.7352 47.6012 81.3429 50.8804 85.3348 52.6808C88.7108 54.2036 98.3416 52.2223 101.683 53.7034C103.395 54.4626 103.654 55.0913 104.408 56.7683C104.895 57.8516 105.597 57.516 106.957 58.6124C107.502 59.0523 107.202 59.0432 107.929 59.2371C107.929 53.8255 107.792 51.4976 106.303 47.4858C104.663 43.0667 101.35 38.6662 97.5756 35.8479C93.2473 32.6156 88.1182 30.7862 82.9121 30.4863H79.8558C76.4255 30.6854 73.023 31.5585 69.8557 33.1435C66.3196 34.9126 64.7337 36.4155 62.1602 39.0247C59.96 41.2555 58.1322 44.1182 56.8994 47.341C55.3564 51.375 55.2188 53.8041 55.2188 59.2371L55.2191 59.2375Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1865 112.547C77.9036 112.547 79.1285 109.194 81.5755 107.555C82.4501 108.141 83.5076 109.388 84.3207 110.201C88.196 114.076 87.4376 113.373 93.8047 107.007L102.299 98.5299C104.251 96.6113 101.686 95.0219 98.7959 92.1319C96.4128 89.7488 95.7741 88.4362 93.4049 90.834L81.5755 102.565L69.8456 90.934C67.4141 88.4854 66.8948 89.5921 64.4546 92.0323C61.8847 94.6026 58.9867 96.5439 60.6503 98.33L69.247 106.907C69.9963 107.656 74.5753 112.547 75.1869 112.547L75.1865 112.547Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5253 98.22L90.6087 89.2353C88.7484 89.5415 86.5462 90.983 81.5745 90.983C79.8748 90.983 78.0522 90.7394 76.7408 90.4261L72.5898 89.1865L81.5253 98.2204V98.22Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_232",
    x1: 91.2792,
    y1: 0.57515,
    x2: 71.9204,
    y2: 162.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D930F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704EEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.2,
    height: 163.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorImg);
export default __webpack_public_path__ + "static/media/tutorImg.f1897f221b096be903048a22e2448dee.svg";
export { ForwardRef as ReactComponent };